import { Link } from "react-router-dom"
import { DashboardChart, IChartComponents } from "../dashboard-chart"
import { CardBody, CardFooter, CardMain, CardTitle } from "./styles"

interface IDashBoardCardProps extends IChartComponents{ 
    title: string;
    linkTo: string;
    linkText: string;
    linkIcon: JSX.Element;

}

export const DashboardCardChart: React.FC<IDashBoardCardProps> = ({title, linkTo, linkText, linkIcon, datasets, labels }) => { 
    return ( 
        <CardBody> 
        <CardTitle> 
            <h1>{title}</h1>
        </CardTitle>
        <CardMain className="p-3">
            <DashboardChart datasets={datasets} labels={labels}/>
        </CardMain>
        <CardFooter>
            <Link to={linkTo} style={{ fontSize: 18, color: '#6473FF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{marginRight: 10}}> {linkText}</span>
                {linkIcon}
            </Link>
        </CardFooter>
    </CardBody>
    )
}